import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import Confirm from '../Dialog/Confirm';
import { history } from '../../helpers';
import { boardService } from '../../services';
import { alertActions } from '../../modules/alert';


class ContentsAdd extends Component {
    constructor(props) {
        super(props);
        if (!props.location.state) history.goBack();
        const { boardInfo } = props.location.state;
        this.state = {
            boardInfo: boardInfo,
            content: '',
            contentKindCode: 'CK001',
            valueChange: false,
            submitted: false,
            open: false
        }
    }

    handleValueChange = (e) => {
        // content 100자 체크
        if (e.target.name === "content" && e.target.value.length > 100) {
            this.props.errorAlerts("경고 100자 초과");
        }
        else {
            this.setState({
                valueChange: true,
                [e.target.name]: e.target.value
            });
        }
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        const { content } = this.state;
        this.setState({
            submitted: true
        });

        if (content) {
            this.addBoard();
        }
    };

    addBoard = () => {
        const { myInfo, mySite } = this.props;

        let formData = new FormData();
        formData.append('siteID', mySite.mySiteID);
        formData.append('boardInfoID', this.state.boardInfo.boardInfoID);
        formData.append('content', this.state.content);
        formData.append('contentKindCode', this.state.contentKindCode);
        formData.append('userID', myInfo.userID);
        
        boardService.addBoard(formData)
            .then((response) => {
                if (response.status === 200) {
                    history.goBack();
                }
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleClose = () => {
        if (this.state.valueChange) {
            this.setState({
                open: true
            });
        }
        else {
            history.goBack();
        }
    };

    handleGoBack = () => {
        history.goBack();
    };

    handleConfirmClose = () => {
        this.setState({
            open: false
        })
    };


    render() {
        const { boardInfo, content, submitted } = this.state;
        return (
            <>
                <h2 className="s-page-tit">
                    {boardInfo.boardName}
                </h2>
                <div className="search-result-wrapper contents-add s-normal-box">
                    <Row>
                        <Col xs={3} md={2} lg={1} className="contents-add-title">내용 <span className="text-color-red">*</span><br/><span className="contents-add-title-length">({content.length}/100)</span></Col>
                        <Col xs={9} md={10} lg={11} className="text-align-left">
                            <textarea className="w100per" style={{padding: "10px 10px", resize: "none"}} rows="5" name="content" value={content} autoFocus onChange={this.handleValueChange} />
                            {submitted && !content &&
                                <div className="text-color-red">* 내용을 입력하세요.</div>
                            }
                        </Col>
                    </Row>
                </div>
                <div className="search-button-wrapper text-align-right">
                    <button className="button w100-button margin-r10" onClick={this.handleFormSubmit} ref={button => this.buttonAdd = button}>등록</button>
                    <button className="button w100-button white-button" onClick={this.handleClose}>닫기</button>
                </div>
                {this.state.open === true &&
                    <Confirm message={"취소하시겠습니까?\n입력된 정보는 삭제됩니다."} kind={"fail"} handleFormSubmit={this.handleGoBack} handleClose={this.handleConfirmClose} />
                }
            </>
        )
    }
}

function mapState(state) {
    const { userinfo, mySite } = state;
    const myInfo = userinfo.item;
    return { myInfo, mySite};
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsAdd);